import { clsx } from 'clsx';
import { type ReactNode } from 'react';

import { useSecondaryNavContext } from './SecondaryNavContext';
import { useSecondaryNavItemContext } from './SecondaryNavItemContext';
import styles from './SecondaryNavList.module.scss';

type ListProps = {
  /**
   * What to render in the `SecondaryNav.Item`.
   */
  children: ReactNode;
  /**
   * Optional property for overriding styles.
   */
  className?: string;
};

export const SecondaryNavList = ({ children, className }: ListProps) => {
  const navItemContext = useSecondaryNavItemContext();
  const { expandedSectionKeys } = useSecondaryNavContext();

  const isTopLevelList = !navItemContext;
  const isHidden = isTopLevelList
    ? undefined // top-level list should always be visible
    : !expandedSectionKeys.includes(navItemContext.itemId);

  return (
    <ul
      className={clsx(styles.secondaryNavList, className)}
      data-zds
      hidden={isHidden}
      id={navItemContext?.listId}
    >
      {children}
    </ul>
  );
};
